import QuotaholdersChart from "components/charts/modern/QuotaholdersChart";
import SharesChart from "components/charts/modern/SharesChart";
import TradesChart from "components/charts/modern/TradesChart";
import {
  CompanyContainer,
  CompanyContentContainer,
  CompanyTabsContent,
  CompanyTabsList,
} from "components/company/v3/CompanyContainers";
import { CompanyLiquidityTabEnum } from "components/company/v3/menu/enums";
import { Tabs } from "components/ui/Tabs";
import { AreaChartIcon, BarChart3Icon, ContactIcon } from "lucide-react";
import { useIntl } from "react-intl";

interface FiisLiquidityBoxProps {
  tickerSymbol: string;
  tab: CompanyLiquidityTabEnum;
  onChangeTab: (tab: CompanyLiquidityTabEnum) => void;
}

export default function FiisLiquidityBox({ tickerSymbol, tab, onChangeTab }: FiisLiquidityBoxProps) {
  const intl = useIntl();

  return (
    <CompanyContainer>
      <CompanyContentContainer>
        <Tabs
          defaultValue={CompanyLiquidityTabEnum.TRADE_HISTORY}
          value={tab}
          onValueChange={(value) => onChangeTab(value as CompanyLiquidityTabEnum)}
          className="h-full w-full"
        >
          <CompanyTabsList
            tabs={[
              {
                value: CompanyLiquidityTabEnum.TRADE_HISTORY,
                label: intl.formatMessage({
                  defaultMessage: "Negócios",
                  description: "Aba do menu superior da empresa",
                  id: "aU3x7h",
                }),
                icon: <BarChart3Icon className="inline-flex" size={16} strokeWidth={2} />,
              },
              {
                value: CompanyLiquidityTabEnum.SHARES_OUTSTANDING,
                label: intl.formatMessage({
                  defaultMessage: "Cotas Emitidas",
                  description: "Aba do menu superior da empresa",
                  id: "eOl0Yb",
                }),
                icon: <AreaChartIcon className="inline-flex" size={16} strokeWidth={2} />,
              },
              {
                value: CompanyLiquidityTabEnum.SHARES_HOLDERS,
                label: intl.formatMessage({
                  defaultMessage: "Cotistas",
                  description: "Aba do menu superior do FII",
                  id: "WPIYVk",
                }),
                icon: <ContactIcon className="inline-flex" size={16} strokeWidth={2} />,
              },
            ]}
          />

          <CompanyTabsContent value={CompanyLiquidityTabEnum.TRADE_HISTORY}>
            <TradesChart tickerSymbols={[tickerSymbol]} />
          </CompanyTabsContent>

          <CompanyTabsContent value={CompanyLiquidityTabEnum.SHARES_OUTSTANDING}>
            <SharesChart tickerSymbols={[tickerSymbol]} />
          </CompanyTabsContent>

          <CompanyTabsContent value={CompanyLiquidityTabEnum.SHARES_HOLDERS}>
            <QuotaholdersChart tickerSymbols={[tickerSymbol]} />
          </CompanyTabsContent>
        </Tabs>
      </CompanyContentContainer>
    </CompanyContainer>
  );
}
